export const UPDATE_TRACK = 'UPDATE_TRACK';
export const updateTrack = (q) => ({
  type: UPDATE_TRACK,
  payload: q,
});
